<template>
  <div id="MosaicContainer">
    <div class="button-container"></div>
    <div v-if="finish" class="finish">
      <div class="success_head">{{ t("SUCCESS") }}</div>
      <div v-for="f in successText" :key="f" class="success_inner">
        <span v-html="f.data"> </span>
      </div>
    </div>
    <div v-if="!started" id="start" class="button" @click="start">START</div>

    <template v-if="started">
      <div class="score">Score: {{ score }}</div>
      <!-- <div>Level: {{ stage }}</div> -->
      <!-- <div>hideTime: {{ hideTime }}ms</div>
      <div>showTime: {{ showTime }}ms</div> -->
      <div id="container" :style="{ width: 60 * this.x + 'px' }">
        <div
          class="cell"
          v-for="(value, index) in tisch"
          :key="index"
          @click="select(index)"
        >
          <div
            class="front"
            :class="[value == 1 || value == 2 ? 'rotate180' : '']"
          ></div>
          <div
            class="back"
            :style="[value == 2 ? 'background:red' : '']"
            :class="[value == 1 || value == 2 ? 'rotate0' : '']"
          ></div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Dict from "../../services/dict_new.js";

export default {
  name: "Mosaic",
  components: {},
  props: {
    sprache: {
      type: String,
      default: () => "english",
    },
    barqId: {
      type: String,
      default: () => "MOS#007",
    },
  },
  watch: {
    barqId: function (newVal) {
      // watch it
      this.loadSetup(newVal);
    },
  },
  data() {
    return {
      tisch: [],
      x: 4,
      y: 4,
      klasse: false,
      preSelection: [],
      preSelectionAmount: 3,
      preSelectionAmountMax: 8,
      wrong: 0,
      correct: 0,
      block: false,
      stage: 0,
      score: 0,
      seconds: 10,
      finish: false,
      maxlevel: 2,
      showTime: 2000,
      showTimeStep: 150,
      showTimeMin: 500,
      hideTime: 1500,
      hideTimeStep: 100,
      hideTimeMin: 700,
      goal: 100,
      started: false,
      toleranz: 2,
      mosaic: [
        {
          x: 4,
          y: 4,
          preSelectionAmount: 3,
          preSelectionAmountMax: 4,
          stage: 0,
          maxlevel: 1,
          showTime: 1700,
          showTimeStep: 150,
          showTimeMin: 500,
          hideTime: 1300,
          hideTimeStep: 100,
          hideTimeMin: 700,
          goal: 100,
          toleranz: 3,
        },
        {
          x: 5,
          y: 4,
          preSelectionAmount: 4,
          preSelectionAmountMax: 6,
          stage: 0,
          maxlevel: 0,
          showTime: 1500,
          showTimeStep: 150,
          showTimeMin: 500,
          hideTime: 1300,
          hideTimeStep: 100,
          hideTimeMin: 700,
          goal: 200,
          toleranz: 2,
        },
        {
          x: 4,
          y: 5,
          preSelectionAmount: 4,
          preSelectionAmountMax: 6,
          stage: 0,
          maxlevel: 2,
          showTime: 1600,
          showTimeStep: 150,
          showTimeMin: 500,
          hideTime: 1200,
          hideTimeStep: 100,
          hideTimeMin: 700,
          goal: 300,
          toleranz: 2,
        },
        {
          x: 5,
          y: 5,
          preSelectionAmount: 4,
          preSelectionAmountMax: 8,
          stage: 0,
          maxlevel: 2,
          showTime: 1200,
          showTimeStep: 150,
          showTimeMin: 500,
          hideTime: 1100,
          hideTimeStep: 100,
          hideTimeMin: 700,
          goal: 350,
          toleranz: 2,
        },
      ],
    };
  },
  //0 show back
  //1 show green = correct
  //2 show red = wrong
  methods: {
    t(word) {
      return Dict(word, this.sprache);
    },
    start() {
      this.started = true;
      this.init();
    },
    updateScore() {
      this.score += 10;
    },
    startNew() {
      this.init();
    },
    nextStage() {
      if (this.score >= this.goal) {
        //player has won
        this.won();
        return;
      }
      // this.updateScore();
      console.log("next Stage");
      this.hide();

      this.block = true;

      this.wrong = 0;
      this.correct = 0;
      this.preSelection = [];

      if (this.stage < this.maxlevel) {
        this.stage++;
        setTimeout(() => {
          if (this.stage % 2) {
            this.x++;
          } else {
            this.y++;
          }
          //draw new grid
          this.hide();

          setTimeout(() => {
            this.init();
          }, 1500);
        }, 500);
      } else {
        //reduce showTime, but not to much

        if (this.showTime > this.showTimeMin) {
          this.showTime -= this.showTimeStep;
          if (this.showTime < this.showTimeMin) {
            this.showTime = this.showTimeMin;
          }
        }
        //draw new grid
        this.hide();
        setTimeout(() => {
          this.init();
        }, this.hideTime);
      }

      if (this.preSelectionAmountMax > this.preSelectionAmount) {
        this.preSelectionAmount++;
      }
    },
    hide() {
      // console.log(this.x);
      // console.log(this.y);
      this.tisch = new Array(this.y * this.x).fill(0);
    },
    init() {
      this.finish = false;
      this.block = true;
      this.tisch = new Array(this.y * this.x).fill(0);

      //get 5 random numbers and preselect them
      this.preSelection = this.randomUniqueIntegers(
        this.x * this.y,
        this.preSelectionAmount
      );
      this.preSelection.forEach((n) => {
        this.tisch[n] = 1;
      });

      setTimeout(() => {
        this.hide();
        this.block = false;
      }, this.showTime);
    },
    select(i) {
      if (this.block) return;
      if (this.tisch[i] == 1) return;
      if (this.preSelection.includes(i)) {
        //user has clicked the correct tile
        this.tisch[i] = 1;
        this.correct++;
        this.updateScore();
        if (this.correct === this.preSelection.length) {
          this.block = true;
          setTimeout(() => {
            this.nextStage();
            //reduce hideTime, but not to much
            if (this.hideTime > this.hideTimeMin) {
              this.hideTime -= this.hideTimeStep;
              if (this.hideTime < this.hideTimeMin) {
                this.hideTime = this.hideTimeMin;
              }
            }
          }, this.hideTime);
        }
      } else {
        //wrong tile
        this.tisch[i] = 2;
        this.wrong++;
        if (this.wrong >= this.toleranz) {
          this.loose();
        }
      }
    },
    won() {
      console.log("win");
      this.finish = true;
      //win animation TODO
    },
    loose() {
      console.log("loose");
      this.reload();
    },
    reset() {
      //reset variables
      //load the setup again
      if (this.setup) {
        console.log("LOADING SETUP");

        for (const key in this.setup) {
          this[key] = this.setup[key];
        }
      }
      this.wrong = 0;
      this.score = 0;
      this.correct = 0;
      this.preSelection = [];
      this.block = true;
      this.stage = 0;

      console.log("Correct after reset" + this.correct);
    },
    reload() {
      //flip all tiles to red
      this.tisch = new Array(this.y * this.x).fill(2);
      setTimeout(() => {
        console.log("reset");
        this.reset();
        this.hide();
        setTimeout(() => {
          this.block = false;
          this.init();
        }, 2000);
      }, 2000);
    },
    wenden() {
      this.klasse = !this.klasse;
    },
    randomUniqueIntegers(total, quantity) {
      const numbers = Array(total)
        .fill(null)
        .map((_, i) => i);

      return numbers
        .map((value) => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value)
        .slice(0, quantity);
    },
    loadSetup(name) {
      if (name == "MOS#005" || name == "MOS#007") {
        this.setup = this.mosaic[0];
      } else if (name == "MOS#112" || name == "MOS#114") {
        this.setup = this.mosaic[1];
      } else if (name == "MOS#118" || name == "MOS#175") {
        this.setup = this.mosaic[2];
      } else if (name == "MOS#130" || name == "MOS#183") {
        this.setup = this.mosaic[3];
      } else {
        this.setup = this.mosaic[1];
      }

      if (this.setup) {
        console.log("LOADING SETUP");

        for (const key in this.setup) {
          this[key] = this.setup[key];
        }
      }
      this.loadSuccessText(name);
    },
    loadSuccessText(name) {
      console.log(name);
      if (!name) {
        this.successText = "";
        return;
      }
      this.successText = this.t(name + "S");
      console.log(this.successText);
    },
  },
  created() {
    //fill in the setup
    this.loadSetup(this.barqId);
  },
};
</script>

<style scoped>
.score {
  color: black;
  text-align: center;
  font-size: 3em;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 4%;
}
.button {
  text-align: center;
  font-size: 3em;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 4%;

  border: 2px solid black;
  width: 130px;
  border-radius: 10px;
  cursor: pointer;
  padding: 10px;

  color: black;
}

.button:hover {
  background: black;
  color: white;
}
#MosaicContainer {
  z-index: 1;
  position: relative;
  aspect-ratio: 1;
  width: 100%;
  margin: 0px 20px;
  background: white;
}

.buttonClass {
  cursor: pointer;
  border: 2px solid black;
  border-radius: 3px;
  width: 100px;
  margin: 5px;
  font-size: 25px;
}

.orangeHover:hover {
  background: var(--orange);
  color: white;
  border: 2px solid var(--orange);
}

* {
  --width: 50px;
}
.cell {
  width: var(--width);
  aspect-ratio: 1;
  margin: 5px;
}

#container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  position: absolute;
  border: 3px solid;
  padding: 5px;
  margin: 50% 50%;
  transform: translate(-50%, -50%);
}

.selected {
  background: var(--orange);
}
.front,
.back {
  width: var(--width);
  aspect-ratio: 1;
  position: absolute;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  transform-style: preserve-3d;
  transition: ease-in-out 250ms;
}

.front {
  background: #9e9e9e;
  cursor: pointer;
}

.back {
  background: lime;
  transform: rotateY(-180deg);
}

.rotate0 {
  transform: rotateY(0deg);
}

.rotate180 {
  transform: rotateY(180deg);
}

.finish {
  position: absolute;
  background: #f2f2f2;
  width: 90%;
  height: 90%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  color: #1aaf54;
  font-size: 30px;
  top: 50%;
  justify-content: space-evenly;
}

.finish > div {
  margin: 0px 10%;
}
</style>
